/**
 * @description 문자열에 공백이 포함되었는지 체크하는 함수
 * @returns boolean, (true: 공백 미포함, false: 공백 포함)
 */

const validateNoSpace = (str: string) => {
  const regex = /\s/g;

  return !regex.test(str);
};

export default validateNoSpace;
